/*LIBRARY*/
import { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";
import Modal from "../common_modal/Modal";
import SPINNER from "../common_spinner/SPINNER";

/*REDUX*/
import {
  get_formula_mapid,
  get_formula_user,
  run_template,
  delete_formula,
  update_formula,
} from "../../App/actions/site_selections";
import { set_value_insight } from "../../App/actions/insight_v2";

/*PICTURE*/
import menu_icon from "../../Assets/svg/menu_icon.svg";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const SS_TEMPLATE = ({
  get_formula_mapid,
  get_formula_user,
  set_value_insight,
  insight_reducer,
  run_template,
  delete_formula,
  auth,
  update_formula,
}) => {
  //component did mount
  useEffect(() => {
    get_formula_mapid();
    get_formula_user();
  }, [get_formula_mapid, get_formula_user]);

  //uses
  const [anchor, set_anchor] = useState(null);
  const [modal_menu_card, set_modal_menu_card] = useState(false);
  const [modal_delete, set_modal_delete] = useState(false);
  const [modal_edit, set_modal_edit] = useState(false);

  //local storage
  const language = localStorage?.language || auth.language;

  //global props
  const {
    formula_mapid_list,
    formula_user_list,
    formula_selected,
    modal_run_template,
  } = insight_reducer;

  //inline function
  const toggle_delete = useCallback(() => {
    set_modal_delete((prev) => !prev);
    set_modal_menu_card(false);
  }, []);

  const toggle_edit = useCallback(() => {
    set_modal_edit((prev) => !prev);
    set_modal_menu_card(false);
  }, []);

  const toggle_menu_card = (event, item = null) => {
    set_modal_menu_card(!modal_menu_card);
    set_anchor(event?.currentTarget);
    set_value_insight({
      key: "formula_selected",
      value: item,
    });
  };

  const on_run_template = (event, formula_selected_run = null) => {
    set_value_insight({
      key: "modal_run_template",
      value: true,
    });
    set_anchor(event?.currentTarget);
    run_template(formula_selected_run);
  };

  const on_change = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    formula_selected[name] = value;
    set_value_insight({
      key: "formula_selected",
      value: formula_selected,
    });
  };

  //content
  const modal_delete_content = modal_delete && (
    <Modal
      modalSize="small"
      id="modal_delete"
      isOpen={modal_delete}
      onClose={() => toggle_delete()}
    >
      <div className="box-body">
        <p className="text_big margin_bottom_extra">
          {
            dict?.["Are you sure you want to delete this formula template?"]?.[
              language
            ]
          }
        </p>
        <button
          className="button_big button_white outline_black"
          onClick={() => {
            delete_formula();
            set_modal_delete(false);
          }}
        >
          {dict?.["Delete template"]?.[language]}
        </button>
      </div>
    </Modal>
  );

  const modal_edit_content = modal_edit && (
    <Modal
      modalSize="small"
      id="modal_edit"
      isOpen={modal_edit}
      onClose={() => toggle_edit()}
    >
      <div className="box-body">
        <p className="text_bold margin_bottom">
          {dict?.["Site Selection Formula Name"]?.[language]}
        </p>
        <input
          type="text"
          className="margin_bottom_extra"
          value={formula_selected?.formula_name || ""}
          name="formula_name"
          onChange={on_change}
          placeholder="Tulis nama formula"
        />
        <section className="text_center">
          <button
            className="button_big background_black"
            onClick={() => {
              update_formula();
              set_modal_edit(false);
            }}
          >
            {dict?.["Save"]?.[language]}
          </button>
        </section>
      </div>
    </Modal>
  );

  const modal_menu_card_content = (
    <FLOAT_MENU
      anchorEl={anchor}
      open={modal_menu_card}
      onClose={() => toggle_menu_card(null)}
    >
      <button
        className="button_big button_white outline_black full_width margin_bottom"
        onClick={() => toggle_edit()}
      >
        Edit
      </button>
      <button
        className="button_big red_container full_width"
        onClick={() => toggle_delete()}
      >
        {dict?.["Delete"]?.[language]}
      </button>
    </FLOAT_MENU>
  );

  const modal_run_template_content = (
    <FLOAT_MENU
      anchorEl={anchor}
      open={modal_run_template}
      onClose={() =>
        set_value_insight({ key: "modal_run_template", value: false })
      }
    >
      {dict?.["Applying the template"]?.[language]}{" "}
      <SPINNER
        unik="ai_spinner"
        width={10}
        border={0.25}
        color1="white"
        color2="#000"
      />
    </FLOAT_MENU>
  );

  return (
    <main>
      {modal_run_template_content}
      {modal_menu_card_content}
      {modal_delete_content}
      {modal_edit_content}
      <p className="badge green_container margin_bottom">
        {dict?.["Template from MAPID"]?.[language]}
      </p>
      {formula_mapid_list.map((item, idx) => {
        return (
          <section
            key={idx}
            className="container background_white outline_grey margin_bottom"
          >
            <p className="text_medium sub_color margin_bottom">
              {item?.formula_name}
            </p>
            <button
              className="button_small button_white outline_black"
              onClick={(event) => on_run_template(event, item)}
            >
              {dict?.["Use"]?.[language]}
            </button>
          </section>
        );
      })}

      <hr
        style={{
          border: "none",
          height: "3px",
          backgroundColor: "#cbd1d8",
          borderRadius: "1.5px",
          margin: "20px 0",
        }}
      />

      <p className="badge blue_container margin_bottom">
        {dict?.["Your Template"]?.[language]}
      </p>
      {formula_user_list.map((item, idx) => {
        return (
          <section
            key={idx}
            className="container background_white outline_grey margin_bottom"
          >
            <div className="two_container margin_bottom">
              <p className="text_medium sub_color">{item?.formula_name}</p>
              <div className="text_right">
                <button
                  className="button button_white"
                  style={{ width: "30px", height: "30px" }}
                  onClick={(event) => toggle_menu_card(event, item)}
                >
                  <img alt="menu" src={menu_icon} height={15} />
                </button>
              </div>
            </div>

            <button
              className="button_small button_white outline_black"
              onClick={(event) => on_run_template(event, item)}
            >
              {dict?.["Use"]?.[language]}
            </button>
          </section>
        );
      })}
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  insight_reducer: state.insight_reducer,
});

export default connect(mapStateToProps, {
  get_formula_mapid,
  get_formula_user,
  set_value_insight,
  run_template,
  delete_formula,
  update_formula,
})(SS_TEMPLATE);
